import { createSelector } from 'reselect'

const featureTrialsSelector = state => state.user.data.account.featuresTrial ? state.user.data.account.featuresTrial : {}

const paywallReminderSelector = createSelector(
	[featureTrialsSelector],
	paywallReminder => ({
		daysLeft: paywallReminder.text || '',
	})
)

export default paywallReminderSelector
